import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BannerLoader } from "./Componnets/Banner/BannerLoader";

{
  let molunaBannerDiv = document.getElementById("molunaBannerDiv");

  if (molunaBannerDiv != null) {
    let configUrl = molunaBannerDiv.getAttribute("data-config");
    if (configUrl != null) {
      let getParentFunc = () => {
        return molunaBannerDiv?.clientHeight??0;
      };

      ReactDOM.render(
        <React.StrictMode>
          <BannerLoader url={configUrl} getparentHeight={getParentFunc}></BannerLoader>
        </React.StrictMode>,
        molunaBannerDiv
      );
    }
  }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
